<template>
  <div id="pdfPreviewDialog" class="pdf-preview-dialog" v-drag @click.stop>
    <div class="pdf-preview-top">
      <span class="title float-left">{{dataInfo.resourceTitle ? dataInfo.resourceTitle : '资源预览'}}</span>
      <i class="iconfont iconclose float-right" @click.stop="$emit('handleClose')"></i>
      <i
        v-if="dataInfo.type !== 2"
        class="iconfont iconquanping2 float-right"
        @click.stop="_fullScreen"
      ></i>
      <el-button-group
        @click.stop
        @mousedown.stop
        @mouseup.stop
        class="tp-or-cw-btns"
        v-if="dataInfo.type === 7 && tp && cw"
      >
        <el-button :type="tpOrCw === 'tp' ? 'primary' : ''" @click.stop="_switch('tp')">教案</el-button>
        <el-button :type="tpOrCw === 'cw' ? 'primary' : ''" @click.stop="_switch('cw')">课件</el-button>
        <el-button v-if="ec" :type="tpOrCw === 'ec' ? 'primary' : ''" @click.stop="_switch('ec')">习题</el-button>
      </el-button-group>
    </div>
    <div
      id="pdfPreviewContent"
      class="pdf-preview-content"
      v-loading="loading"
      element-loading-text="视频正在跑步加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
    >
      <!-- 1:视频 2:交互课件 3:微课 4:题库子 5:教案 6:课件 7:教案课件 -->
      <!-- 教案预览 -->
      <teaching-plan-preview
        v-if="pdfUrl && tpOrCw === 'tp' && (dataInfo.type === 4 || dataInfo.type === 5 || dataInfo.type === 7)"
        :key="pdfUrl"
        ref="tPlanPreview"
        :pdfUrl="pdfUrl"
        :resourceId="dataInfo.type === 7 && tp && cw ? null : dataInfo.resourceId"
        :level="dataInfo.levelId"
        :subject="dataInfo.subjectId"
      />
      <!-- 习题处理 -->
      <teaching-plan-preview
        v-if="ec && pdfUrl && tpOrCw === 'ec' && (dataInfo.type === 4 || dataInfo.type === 5 || dataInfo.type === 6 || dataInfo.type === 7 || dataInfo.type === 9)"
        :key="pdfUrl"
        ref="ePlanPreview"
        :pdfUrl="pdfUrl"
        :resourceId="dataInfo.type === 7 && tp && cw ? null : dataInfo.resourceId"
        :level="dataInfo.levelId"
        :subject="dataInfo.subjectId"
      />
      <!-- 课件预览 -->
      <ppt-preview
        v-else-if="pdfUrl && tpOrCw === 'cw' && (dataInfo.type === 6 || dataInfo.type === 7)"
        :key="pdfUrl"
        ref="coursewarePreview"
        :pdfUrl="pdfUrl"
        :coverUrl="dataInfo.customResourceDetailCoverUrl"
        :thumbnails="cw && cw.thumbnails ? cw.thumbnails : []"
        :videos="cw && cw.videos ? cw.videos : {}"
        :resolution="cw && cw.resolution ? cw.resolution : '960*720'"
        :fixed-size="true"
        box-id="pdfPreviewContent"
        :resourceId="dataInfo.type === 7 && tp && cw ? null : dataInfo.resourceId"
        :level="dataInfo.levelId"
        :subject="dataInfo.subjectId"
      />
      <!-- 交互课件 -->
      <div class="resource-type-2" v-else-if="dataInfo.type === 2">
        <img v-if="dataInfo.id || dataInfo.detailSourceType === 3" :src="dataInfo.coverUrl" alt="">
        <img
          v-else
          :src="imgSrc + `/images/${dataInfo.preUrl}/${dataInfo.resourceId}/${dataInfo.coverUrl}`"
          alt=""
        >
        <div class="mask-box">
          <p>
            本资源暂不支持在线预览，请
            <span
              class="download-span"
              @click.stop="$emit('handleDownload', dataInfo)"
            >下载</span>使用
          </p>
        </div>
      </div>
      <!-- <div class="pdf-error" v-if="(!pdfUrl || pdfError) && !loading">
        <p>404！资源加载失败</p>
      </div>-->
    </div>
  </div>
</template>
<script>
import TeachingPlanPreview from "components/doc-ppt-preview/doc-preview";
import PptPreview from "components/doc-ppt-preview/ppt-preview.vue";
import { reqGetPrepareDetail } from "api/my-task";
import { SetVideoStatistics } from "api/common";

export default {
  components: {
    TeachingPlanPreview,
    PptPreview
  },
  props: {
    dataInfo: {
      type: Object
    },
    imgSrc: {
      type: String
    }
  },
  data() {
    return {
      cw: null,
      tp: null,
      tpOrCw: "tp",
      pdfUrl: "",
      loading: true
    };
  },
  watch: {
    dataInfo: {
      deep: true,
      immediate: true,
      handler(obj) {
        // 1:视频 2:交互课件 3:微课 4:题库子 5:教案 6:课件 7:教案课件
        if (obj.customResourceId && (obj.type === 6 || obj.type === 7)) {
          this._getPrepareDetail(obj.customResourceId);
        } else if (obj.previewUrl) {
          this.pdfUrl = obj.previewUrl;
          setTimeout(() => {
            this.loading = false;
          }, 300);

          this.cw = null;
        } else {
          setTimeout(() => {
            this.loading = false;
          }, 300);
          this.cw = null;
        }
      }
    }
  },
  directives: {
    drag: {
      // 指令的定义
      inserted: function(el) {
        el.onmousedown = function(e) {
          let _class = $(e.target).attr("class");
          if (
            _class.indexOf("pdf-preview-top") === -1 &&
            _class.indexOf("title") === -1
          ) {
            return;
          }
          let moveEle = $("#pdfPreviewDialog"),
            x = 0,
            y = 0,
            nx = 0,
            ny = 0,
            nl = 0,
            nt = 0,
            l = 0,
            t = 0,
            ml = 0,
            mt = 0,
            isDown = false;
          //获取x坐标和y坐标
          x = e.clientX;
          y = e.clientY;
          //获取左部和顶部的偏移量
          l = moveEle.offset().left;
          t = moveEle.offset().top;

          ml = moveEle.css("marginLeft");
          ml = ml.replace("px", "");
          mt = moveEle.css("marginTop");
          mt = mt.replace("px", "");
          document.onmousemove = function(e) {
            //获取x和y
            nx = e.clientX;
            ny = e.clientY;
            //计算移动后的左偏移量和顶部的偏移量
            nl = nx - (x - l) - ml;
            nt = ny - (y - t) - mt;

            moveEle.css({ left: nl + "px", top: nt + "px" });
          };
          document.onmouseup = function(e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    /**
     * vs4关闭预览
     * **/
    _vs4Close(data) {
      this.$refs.videoWrapper._videoPause();
      if (data === "switch") {
        return;
      }
      this.$emit("handleClose");
    },
    _switch(type) {
      this.tpOrCw = type;
      // if (type === "tp") {
      //   this.pdfUrl = this.tp
      //     ? this.tp.customResourceDetailTargetFileUrl
      //     : this.pdfUrl;
      // } else {
      //   this.pdfUrl = this.cw.customResourceDetailTargetFileUrl;
      // }

      if (type === "tp") {
        this.pdfUrl = this.tp
          ? this.tp.customResourceDetailTargetFileUrl || this.tp.previewUrl
          : this.pdfUrl;
      }
      // 习题处理
      if (type === "ec") {
        this.pdfUrl = this.ec
          ? this.ec.customResourceDetailTargetFileUrl || this.ec.previewUrl
          : this.pdfUrl;
      }
      if (type === "cw") {
        this.pdfUrl =
          this.cw.customResourceDetailTargetFileUrl || this.cw.previewUrl;
      }
    },

    /**
     * 获取备课详情
     * **/
    _getPrepareDetail(id) {
      let obj = {
        customResourceId: id,
        operationType: 1
      };
      this.loading = true;
      return reqGetPrepareDetail(obj)
        .then(res => {
          this.loading = false;
          if (res.code === 0 || res.code === 200) {
            let _data = res.data;
            this.tp = _data.teachingPlan ? _data.teachingPlan : null;
            this.cw = _data.courseware ? _data.courseware : null;
            // 习题处理
            this.ec = _data.exercise ? _data.exercise : null;
            if (this.tp && this.tp.customResourceDetailTargetFileUrl) {
              this.pdfUrl = this.tp.customResourceDetailTargetFileUrl;
            } else if (this.cw && this.cw.customResourceDetailTargetFileUrl) {
              this.pdfUrl = this.cw.customResourceDetailTargetFileUrl;
              this.tpOrCw = "cw";
            } else if (this.ec && this.ec.customResourceDetailTargetFileUrl) {
              // 习题处理
              this.pdfUrl = this.ec.customResourceDetailTargetFileUrl;
              this.tpOrCw = "ec";
            }
            if (this.tp && this.cw) {
              SetVideoStatistics({
                resourceId: this.dataInfo.resourceId,
                level: this.level,
                subject: this.subject,
                type: "preview"
              });
            }
          }
        })
        .catch(err => {
          this.loading = false;
          console.log("_getPrepareDetail--error", err);
        });
    },

    /**
     * 全屏预览
     * **/
    _fullScreen() {
      if (this.tpOrCw === "tp") {
        !this.$refs.tPlanPreview.pptError &&
          this.$refs.tPlanPreview._fullScreen();
      } else if (this.tpOrCw === "cw") {
        !this.$refs.coursewarePreview.pptError &&
          this.$refs.coursewarePreview._fullScreen();
        setTimeout(() => {
          // this.$refs.coursewarePreview._resizeEvent();
        }, 500);
        this.$nextTick(() => {});
      } else if (this.tpOrCw === "ec") {
        !this.$refs.ePlanPreview.pptError &&
          this.$refs.ePlanPreview._fullScreen();

        this.$nextTick(() => {});
      }
    }
  }
};
</script>
<style lang="less">
.pdf-preview-dialog {
  width: 977px;
  height: 600px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -488px;
  margin-top: -300px;
  box-shadow: 0 10px 20px 0 rgba(0, 46, 54, 0.2);
  z-index: 999;

  .pdf-preview-top {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #03b2b2;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    cursor: move;
    padding: 0 20px;

    // .tp-or-cw-btns .el-button {
    //   border-width: 0 !important;
    //   background: #fff;
    //   color: #00a0a0;
    //   padding: 12px 15px;
    // }
    .el-button-group > .el-button:not(:last-child) {
      margin-right: 1px;
    }

    .title {
      max-width: 70%;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 18px;
      float: left;
      color: #fff;
    }

    .iconfont {
      cursor: pointer;
      font-size: 20px;
      color: #fff;

      &.iconquanping2 {
        font-size: 18px;
        padding: 0 20px;
      }

      &:hover {
        text-shadow: 0 0 2px #fff;
      }
    }

    .tp-or-cw-btns {
      float: right;
      padding-right: 20px;
      padding-top: 6px;
      .el-button {
        border-width: 0 !important;
        border-right: 1px solid #000;
        background: #fff;
        color: #00a0a0;
        padding: 12px 15px;
        &:hover {
          background: rgb(210, 255, 244) !important;
        }
        &.el-button--primary {
          background: #058868;
          border-color: #03b2b2 !important;
          color: #fff;
          &:focus {
            opacity: 1 !important;
          }
          &:hover {
            background: #058868 !important;
            border-color: #03b2b2 !important;
          }
        }
      }
    }
  }

  .pdf-preview-content {
    width: 100%;
    height: 550px;
    margin-top: 50px;
    background: #fff;

    .ppt-preview {
      width: 100% !important;
      height: 100% !important;
    }

    .pdf-error {
      width: 100%;
      height: 100%;
      position: relative;

      p {
        width: 100%;
        font-size: 30px;
        color: #7c7c7c;
        font-weight: bold;
        text-align: center;
        position: absolute;
        top: 50%;
        margin-top: -15px;
      }
    }

    .el-loading-spinner {
      margin-top: -21px !important;
    }

    .resource-type-2 {
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      position: relative;
      text-align: center;

      img {
        max-width: 100%;
        height: 100%;
      }

      .mask-box {
        display: none;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
        position: absolute;
        top: 0;
        left: 0;

        p {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 22px;
        }
      }

      &:hover {
        .mask-box {
          display: block;
        }
      }
    }

    .vs4-preview {
      margin-top: -240px;
    }
  }
}
</style>